export default __webpack_public_path__ + "static/media/calendario.ab7a3d19.svg";